import { render, staticRenderFns } from "./RouterButton.vue?vue&type=template&id=b74a669e&scoped=true&"
import script from "./RouterButton.vue?vue&type=script&lang=js&"
export * from "./RouterButton.vue?vue&type=script&lang=js&"
import style0 from "./RouterButton.vue?vue&type=style&index=0&id=b74a669e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74a669e",
  null
  
)

export default component.exports